import React from "react";
import { navigate, Link } from "gatsby";
import axios from "axios";
import { Checkbox, HelpText } from "../Section";
import PrimaryButton from "../Button/PrimaryButton";
import LineArrowRight from "../Icons/LineArrowRight";
import { FormWrap, FormAction, FormRow, FormTwoCol, FormCol } from "../FormStyle";

class QuoteForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      full_name: "",
      email: "",
      phone: "",
      zipcode: "",
      comment: "",
      agreeViaSms: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
		if (typeof window !== 'undefined') 
		{
			const searchParams = new URLSearchParams(window.location.search);
			if(searchParams.get("utm_source")!='' && searchParams.get("utm_source")!=null)
			{
				sessionStorage.setItem('utm_source', searchParams.get("utm_source"));
				sessionStorage.setItem('utm_medium', searchParams.get("utm_medium"));
				sessionStorage.setItem('utm_campaign', searchParams.get("utm_campaign"));
				sessionStorage.setItem('utm_term', searchParams.get("utm_term"));
				sessionStorage.setItem('utm_content', searchParams.get("utm_content"));
			}
		}
	}

  handleChange(event) {
    const { id, value } = event.target;
    if (id !== "agreeViaSms") {
      this.setState({
        [id]: value,
      });
      if (id === "comment") {
        if (!value || value.trim() === "") {
          event.target.setCustomValidity("Please fill out this field.");
        } else {
          event.target.setCustomValidity("");
        }
      }
    } else {
      this.setState({
        [id]: event.target.checked,
      });
    }
  }
  handleSubmit(event) {
    let utm_source_val = 'website';
    let utm_medium_val = '';
    let utm_campaign_val = '';
    let utm_term_val = '';
    let utm_content_val = '';
    if(sessionStorage.getItem('utm_source')!='' && sessionStorage.getItem('utm_source')!=null) 
    {
      utm_source_val = sessionStorage.getItem('utm_source');
      utm_medium_val = sessionStorage.getItem('utm_medium');
      utm_campaign_val = sessionStorage.getItem('utm_campaign');
      utm_term_val = sessionStorage.getItem('utm_term');
      utm_content_val = sessionStorage.getItem('utm_content');
    }
    event.preventDefault();

    const { location } = this.props;
    const data = {
      source: location.origin,
      form: "Quote Form",
      page: location.pathname,
      first_name: this.state.full_name,
      email: this.state.email,
      phone_no: this.state.phone,
      zipcode: this.state.zipcode,
      comment: this.state.comment + ", SMS consent : " + this.state.agreeViaSms,
      agreeViaSms: this.state.agreeViaSms,
      utm_medium: utm_medium_val,
      utm_term: utm_term_val,
      utm_campaign: utm_campaign_val,
      utm_content: utm_content_val,
      lead_source: utm_source_val,
    };
    //console.log("==========", data)
    axios({
      method: "post",
      url: "https://crm.senseicrm.com/api/create-lead-wordpress",
      data: data,
      headers: { Authorization: "Bearer " + process.env.GATSBY_FORM_CRM_TOKEN },
    })
      .then((res) => {
        this.setState({
          full_name: "",
          email: "",
          phone: "",
          zipcode: "",
          comment: "",
          agreeViaSms: false,
        });
        navigate("/thank-you-get-a-quote");
      })
      .catch((error) => {
        alert(error);
      });
  }
  render() {
    return (
      <FormWrap>
        <form id="QuoteForm" onSubmit={this.handleSubmit}>          
          <FormRow className="form-row">
            <FormTwoCol className="form-col">
              <div className="form-group">
                <input
                  type="text" name="full_name"
                  id="full_name"
                  onChange={this.handleChange}
                  placeholder="Full Name"
                  pattern="^(?!\s*$)[A-Za-z\s]+$"
                  required
                  className="form-control"
                />
              </div>
            </FormTwoCol>
            <FormTwoCol className="form-col">
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  id="email"
                  onChange={this.handleChange}
                  placeholder="Email Id"
                  required
                  className="form-control"
                />
              </div>
            </FormTwoCol>
            <FormTwoCol className="form-col">
              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  id="phone"
                  onChange={this.handleChange}
                  placeholder="Contact Number"
                  pattern="[0-9]{10}"
                  required
                  className="form-control"
                />
              </div>
            </FormTwoCol>
            <FormTwoCol className="form-col">
              <div className="form-group">
                <input
                  type="text"
                  name="zipcode"
                  id="zipcode"
                  onChange={this.handleChange}
                  pattern="^[0-9]{5}$"
                  placeholder="Zip Code"
                  required
                  className="form-control"
                />
              </div>
            </FormTwoCol>
            <FormCol className="form-col">
              <div className="form-group">
                <textarea
                  name="comment"
                  placeholder="comment"
                  onChange={this.handleChange}
                  id="comment"
                  rows="4"
                  required
                  className="form-control"
                />
              </div>
            </FormCol>
            <FormCol className="form-col">
              <div className="form-group-check">
                <Checkbox>
                  <label>
                    <input
                      className="form-control"
                      type="checkbox"
                      id="agreeViaSms"
                      name="agreeViaSms"
                      defaultChecked={true}
                      onChange={this.handleChange}
                      aria-label="contacted via SMS"
                    />
                  </label>
                </Checkbox>
                <HelpText>By submitting this form, I agree to receive text messages from Buildings And More. Standard messaging rates and data charges may apply. Message frequency may vary. You can opt-out by replying STOP at any time or reply HELP to get more information. See our <Link to="/privacy-policy">Privacy Policy</Link> and <Link to="/terms-and-conditions">Terms</Link>. We do not share your mobile info with third parties for marketing.</HelpText>
              </div>
            </FormCol>
          </FormRow>
          <FormAction><button type="submit"><PrimaryButton text="Submit" icon={<LineArrowRight />} /></button></FormAction>
        </form>
      </FormWrap>
    );
  }
}
export default QuoteForm;